import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled, { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { ReactComponent as ChevronDownIcon } from "feather-icons/dist/icons/chevron-down.svg";

const PrimaryBackgroundContainer = tw(Container)`-mx-8 px-8 bg-primary-900 text-gray-100`;

const HeadingContainer = tw.div``;
const Subheading = tw(SubheadingBase)`text-center text-gray-100 mb-4`;
const Heading = tw(SectionHeading)``;
const Description = tw(SectionDescription)`mx-auto text-center text-gray-300`;

const FaqsContainer = tw.div`mt-10 sm:mt-16 w-full flex-1 lg:flex justify-between items-start max-w-screen-lg mx-auto`;
const FaqsColumn = tw.div`w-full lg:max-w-lg lg:mr-12 last:mr-0`;
const Faq = tw.div`select-none cursor-pointer border-b-2 border-primary-300 hover:border-primary-500 transition-colors duration-300 py-6`;
const Question = tw.div`flex justify-between items-center`;
const QuestionText = tw.div`text-sm sm:text-lg font-semibold tracking-wide`;
const QuestionToggleIcon = styled(motion.span)`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const Answer = tw(motion.div)`hidden text-sm font-normal mt-4 text-gray-300`;

export default ({
  subheading = "",
  heading = "Return to Fencing - FAQ",
  description = "updated 23/05/2021",
  faqs = [
    {
      question: "Where and When?",
      answer:
        <ul>
          <li>
            Penparcau Community Hub (<a href='https://penparcau.cymru/'><u>website</u></a>).
            <br />
            Every Thursday from 19:00 to 21:00.
          </li>
        </ul>
    },
    {
      question: "What do I need to do before I arrive?",
      answer:
      <ul>
        <li>Ensure you’re a member of British Fencing and all your contact details are up to date. <b>No BF membership = no fencing</b>.
        </li>
        <br />
        <li>All sessions must be booked by sending an email to the club by the Wednesday ahead of the Thursday session.</li>
        <br />
        <li>Read club e-mails and check the website for changes to rules and guidance.</li>
      </ul> 
    },
    {
      question: "How can I book a spot?",
      answer:
      <ul>
        <li>You need to <u><a href="mailto:aberfencing@gmail.com">email us</a></u> by the Wednesday prior to the Thursday session.</li>
        <br/>
        <li>
          Your booking is a declaration that you do not have any covid symptoms, that we can hold and store a record of your attendance and share it with track & trace if necessary.
        </li>
        <br/>
        <li>
          Every Sunday we'll send out an email calling for bookings for the following week.
        </li>
      </ul>
    },
    {
      question: "What if I don't have equipment?",
      answer:
      <ul>
        <li>We can loan you any kit you need. Just <u><a href="mailto:aberfencing@gmail.com">email us</a></u> to say what you need.
          <br />
          <br />
          Equipment will be brought to the session for you. You can then keep it until such time that it is considered safe to resume sharing equipment.
        </li>
      </ul>
    },
    {
      question: "What do I need to do at the session?",
      answer:
      <ul>
        <li>There will be no changing facilities available so please come ready to fence.</li>
        <br />
        <li>Bring your own water and bottle.</li>
        <br />
        <li>Follow hygiene procedures.</li>
        <br />
        <li>Follow the signage and guidance from the venue on use of transit areas, toilets (these are single use only and have a one-way system in place).</li>
        <br />
        <li>Ensure social distance is maintained when entering / leaving the premises.</li>
        <br />
        <li>We are encouraging all attendees to bring their own first aid kit and self-treat where possible.</li>
      </ul> 
    },
    {
      question: "What hygiene procedures do I need to follow?",
      answer:
      <ul>
        <li>Cough or sneeze into your elbow or into a tissue.</li>
        <br />
        <li>Use only single-use tissues and dispose of them in pedal-operated covered garbage cans.</li>
        <br />
        <li>Avoid touching your face with your hands.</li>
        <br />
        <li>Wash hands before and after every session (use hand sanitisers if washing facilities not available)</li>
        <br />
        <li>Individuals to bring own hand sanitisers.</li>
        <br />
        <li>All participants encouraged to shower and wash clothes (including gloves) and clean personal equipment after each session.</li>
        <br />
        <li>Use hand sanitisers on arrival and exit.</li>
      </ul>
    },
    {
      question: "How’s fencing different?",
      answer:
      <ul>
        British Fencing has published a guide to indoor fencing which we are adopting & has been included in our risk assessment, a summary of key changes:
        <br />
        <br />
        <li>Fencing bubbles – a maximum of 6 fencers will be bubbled for the session & these will be the people you can fence with that week.</li>
        <br />
        <li>Sparring between two individuals is limited to 1 x 15 hits of 3 x 5 hits – max 10 mins fencing and 15 mins elapsed.</li>
        <br />
        <li>No corps a corps, fleche, close quarters (updated today - fleche possible based on coaches risk assessment) .</li>
        <br />
        <li>No hand shaking.</li>
        <br />
        <li>For those not fencing 2m social distancing and mask wearing is required.</li>
        <br />
        <li>No sharing of equipment.</li>
        <br />
        <li>Cleaning protocol in place for scoring apparatus.</li>
      </ul>
    },
    {
      question: "How do I pay?",
      answer: "We will not be taking cash payments for sessions – you will be invoiced later at £5/session with payment expected by bank transfer"
    },
    {
      question: "Where can I find the club's risk assessment?",
      answer:
        <a href='https://drive.google.com/file/d/1lDQuW2MscmopzqpTD_2WHoDneiA2yLbC/view?usp=sharing'><u>Click here.</u></a>
    },
    {
      question: "Can I have this information as a PDF?",
      answer:
        <>
          Sure, <a href='https://drive.google.com/file/d/1jeAZjw32SlN43T8bIE2m_morBes1rDIq/view'><u>click here</u>.</a>
        </>
    },
  ]
}) => {
  const faqCol1 = [];
  const faqCol2 = [];
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  faqs.map((faq, index) => {
    const renderedFaq = (
      <Faq key={index} onClick={() => toggleQuestion(index)}>
        <Question>
          <QuestionText>{faq.question}</QuestionText>
          <QuestionToggleIcon
            variants={{
              collapsed: { rotate: 0 },
              open: { rotate: -180 }
            }}
            initial="collapsed"
            animate={activeQuestionIndex === index ? "open" : "collapsed"}
            transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <ChevronDownIcon />
          </QuestionToggleIcon>
        </Question>
        <Answer
          variants={{
            open: { opacity: 1, height: "auto", marginTop: "16px", display: "block" },
            collapsed: { opacity: 0, height: 0, marginTop: "0px", display: "none" }
          }}
          initial="collapsed"
          animate={activeQuestionIndex === index ? "open" : "collapsed"}
          transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
        >
          {faq.answer}
        </Answer>
      </Faq>
    );

    if (index < (faqs.length / 2)) faqCol1.push(renderedFaq);
    else faqCol2.push(renderedFaq);

    return null;
  });
  
  return (
    <PrimaryBackgroundContainer>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          <Description>{description}</Description>
        </HeadingContainer>
        <FaqsContainer>
          <FaqsColumn>{faqCol1}</FaqsColumn>
          <FaqsColumn>{faqCol2}</FaqsColumn>
        </FaqsContainer>
      </ContentWithPaddingXl>
    </PrimaryBackgroundContainer>
  );
};
